module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-red-on-white-f5679f2f6624a40564530899c6730910.svg";